import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import styles from "./MobileHeader.module.css";
import LogoIcon from "../images/Logo.png";
import UpcomingMatches from "../RightSidebar/UpcomingMatches";
import { NotificationContext } from "../../createContext/Notification/NotificationContext";
import Live_img from "../images/liveScore2.gif"; // Import Live Score image

const Header = () => {
  const navigate = useNavigate();
  const [showCalendar, setShowCalendar] = useState(false);
  const { unreadCount } = useContext(NotificationContext);

  const handleNotificationClick = () => {
    navigate("/notification");
  };

  const handleCalendarClick = () => {
    setShowCalendar((prev) => !prev);
    document.body.style.overflow = !showCalendar ? "hidden" : "auto";
  };

  const handleLiveScoreClick = () => {
    localStorage.setItem("score", "Football");
    navigate("/search");
  };

  return (
    <>
      <div className={`${styles.headerWrapper} ${showCalendar ? styles.headerHidden : ""}`}>
        <div className={styles.logoContainer}>
          <img src={LogoIcon} alt="Isiko logo" className={styles.logoImage} />
          <div className={styles.iconContainer}>
            {/* Calendar Button */}
            <div
              className={styles.iconHeader}
              role="button"
              aria-label="Calendar"
              onClick={handleCalendarClick}
              style={{ cursor: "pointer" }}
            >
              📆
            </div>

            {/* Notification Button */}
            <div
              className={styles.iconHeader}
              role="button"
              aria-label="Notifications"
              onClick={handleNotificationClick}
              style={{ cursor: "pointer" }}
            >
              🔔
              {unreadCount > 0 && (
                <span className={styles.notificationBadge}>{unreadCount}</span>
              )}
            </div>
          </div>
          {/* Live Score Button with Image */}
          <div
              className="h-[50px] w-[55px] absolute right-0 flex items-center"
              role="button"
              aria-label="Live Score"
              onClick={handleLiveScoreClick}
              style={{ cursor: "pointer" }}
            >
              <img src={Live_img} alt="Live Score"/>
            </div>
        </div>
        
      </div>
      

      {showCalendar && (
        <div className={styles.calendarOverlay}>
          <div className={styles.calendarContainer}>
            <div className={styles.calendarHeader}>
              <button
                onClick={handleCalendarClick}
                className={styles.closeButton}
                aria-label="Close calendar"
              >
                <X size={24} />
              </button>
            </div>
            <UpcomingMatches />
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
